
export default {
    name: 'LocationBusinesses',
    props: {
        location: {
            type: Object,
            required: true,
        },
        radius: {
            type: Number,
            required: true,
        },
        service: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            businesses: [],
        };
    },
    async fetch() {
        const businesses = await this.$axios.$get(this.$config.endpoints.organisation, {
            params: {
                per_page: 3,
                lat: this.location.lat,
                lon: this.location.lon,
                radius: this.radius,
                service_id: this.service,
            },
        });

        this.businesses = businesses?.organisations?.data || [];
    },
};
